<div
  class="suborganization-card"
  data-cy="add-suborganization-card"
  [class.selected]="
    isSelected && flow === editSuborganizationsRoleAssignmentFlow.Add
  "
  [class.clickable]="
    !isSelected && flow === editSuborganizationsRoleAssignmentFlow.Add
  "
  (click)="added.emit()"
  (keydown.enter)="added.emit()"
>
  <span class="suborganization-name">{{ suborganizationName }}</span>

  @if (flow === editSuborganizationsRoleAssignmentFlow.Add) {
    <markant-icon
      icon="m_plus-small"
      class="suborganization-action-icon"
    ></markant-icon>
  } @else if (
    flow === editSuborganizationsRoleAssignmentFlow.Preview &&
    !isOverallResponsibility
  ) {
    <markant-icon
      icon="m_minus-small"
      class="suborganization-action-icon"
      data-cy="remove-suborganization-button"
      (click)="removed.emit()"
      (keydown.enter)="removed.emit()"
    ></markant-icon>
  }
</div>
